module.exports = __webpack_public_path__ + "img/newspic.99bc74df.jpg";